/**
 * Equipment Library, Quick Capture and audio playback events.
 *
 * One slice of the `ANALYTICS_EVENTS` SSOT — see `../analytics.ts`, which
 * spreads every slice back into the single import surface call sites use.
 * The event NAME STRINGS are a PostHog dashboard contract: add and retire keys
 * here, never rename a value in place (see `rules/analytics.md`).
 */

export const CAPTURE_EVENTS = {
  // Equipment Library
  EQUIPMENT_CREATED: 'Equipment Created',
  EQUIPMENT_SCANNED: 'Equipment Scanned',
  EQUIPMENT_ASK_BIRD_CLICKED: 'Equipment Ask Bird Clicked',
  EQUIPMENT_UPDATED: 'Equipment Updated',
  EQUIPMENT_PHOTO_UPLOADED: 'Equipment Photo Uploaded',
  EQUIPMENT_SEARCH_ONLINE_USED: 'Equipment Search Online Used',
  EQUIPMENT_PHONE_CAPTURE_QR_DISPLAYED: 'Equipment Phone Capture QR Displayed',
  EQUIPMENT_PHONE_CAPTURE_STARTED: 'Equipment Phone Capture Started',
  QR_PATH_REJECTED: 'QR Path Rejected',
  EQUIPMENT_DELETED: 'Equipment Deleted',
  EQUIPMENT_KNOWLEDGE_DELETED: 'Equipment Knowledge Deleted',
  EQUIPMENT_VIEWED: 'Equipment Viewed',

  // Quick Capture
  CAPTURE_VOICE_STARTED: 'Capture Voice Started',
  CAPTURE_VOICE_COMPLETED: 'Capture Voice Completed',
  CAPTURE_VOICE_CANCELLED: 'Capture Voice Cancelled',
  CAPTURE_VOICE_LIMIT_REACHED: 'Capture Voice Limit Reached',
  /** Mobile capture couldn't open the microphone (`stage: 'microphone'`) or
   *  create or start the recorder on it (`stage: 'recorder_setup'`, the same
   *  value desktop's VOICE_RECORDING_FAILED uses). Carries
   *  `failure_reason` (the DOMException name) so the cause distribution is
   *  answerable from data: on a phone a denial is NOT the likeliest cause. */
  CAPTURE_VOICE_FAILED: 'Capture Voice Failed',
  CAPTURE_PHOTO_COMPLETED: 'Capture Photo Completed',
  CAPTURE_VIDEO_COMPLETED: 'Capture Video Completed',
  /** A video rejected by the client-side pre-flight (too large / too long)
   * BEFORE any bytes were uploaded. The signal we want is how often real phone
   * recordings exceed the caps, and on which axis. */
  CAPTURE_VIDEO_LIMIT_REACHED: 'Capture Video Limit Reached',
  CAPTURE_TEXT_COMPLETED: 'Capture Text Completed',
  CAPTURE_MODE_SWITCHED: 'Capture Mode Switched',
  CAPTURE_COLLECTION_CREATED_INLINE: 'Capture Collection Created Inline',
  CAPTURE_DESTINATION_SELECTED: 'Capture Destination Selected',
  CAPTURE_RESTORED: 'Capture Restored',
  CAPTURE_INTERRUPTED: 'Capture Interrupted',

  // Audio Player
  AUDIO_PLAYER_PLAYED: 'Audio Player Played',
  AUDIO_PLAYER_SEEKED: 'Audio Player Seeked',
} as const;
